<div class="w-full max-w-300 mx-auto px-4 md:px-0 py-6 font-sans">
  <div
    class="relative w-full h-45 md:h-55 bg-[linear-gradient(135deg,#BFECF0_0%,#93D4EB_50%,#F5F7FA_100%)] rounded-xl mb-32 md:mb-20"
  >
    <div
      class="absolute -bottom-20 md:-bottom-12 left-0 w-full px-4 md:px-10 flex flex-col md:flex-row items-center md:items-center gap-4 md:gap-6 z-10"
    >
      <div
        class="w-32 h-32 md:w-36 md:h-36 rounded-full border-[6px] border-[#ffffff] shadow-sm bg-[#080d1a] shrink-0 flex items-center justify-center overflow-hidden"
      >
        <img
          [src]="storeInfo().logo"
          class="w-full h-full object-cover"
          alt="Store Logo"
        />
      </div>

      <div
        class="flex-1 w-full bg-[#FFFFFFCC] rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.08)] border border-slate-50 p-6 flex flex-col md:flex-row items-center justify-between gap-6"
      >
        <div class="text-center md:text-left rtl:md:text-right">
          <h1
            class="text-[22px] md:text-[24px] font-bold text-[#14678E] tracking-tight mb-2"
          >
            {{ storeInfo().name }}
          </h1>

          <div
            class="flex flex-wrap justify-center md:justify-start items-center gap-x-5 gap-y-2 text-slate-500 text-[13px] font-medium"
          >
            <div class="flex items-center gap-3 justify-center">
              <sham-i-package class="w-4 h-4 text-slate-400"></sham-i-package>
              <span
                >{{ storeInfo().productsCount }}
                {{ 'Seller.Products' | translate }}</span
              >
            </div>
            <div class="flex items-center gap-3 justify-center">
              <sham-i-RatingStar class="w-4 h-4 text-[#FFC107]"></sham-i-RatingStar>
              <span
                >{{ storeInfo().rating }}/5 {{ 'Seller.Rating' | translate }}</span
              >
            </div>
            <div class="flex items-center gap-3 justify-center">
              <sham-i-Calendar class="w-4 h-4 text-slate-400"></sham-i-Calendar>
              <span>
                {{ 'Seller.Joins' | translate }} {{ storeInfo().joinDate }}</span
              >
            </div>
          </div>
        </div>

        <button
          [routerLink]="['./reviews']"
          class="w-full md:w-auto bg-[#2596BE] hover:bg-[#1E789B] text-[#ffffff] px-6 py-2.5 rounded-lg text-base font-medium transition-colors duration-200 shrink-0"
        >
          {{ 'Seller.ShowReviews' | translate }}
        </button>
      </div>
    </div>
  </div>

  <main class="mt-28 md:mt-24">
    <div class="flex flex-row justify-between items-center mb-6 pb-2">
      <h2 class="text-[16px] font-semibold text-[#2596BE] tracking-wide">
        {{ 'Sort By' | translate }}
      </h2>

      <div class="flex gap-3">
        <div class="relative">
          <select
            (change)="onSortChange($event)"
            [value]="currentSort()"
            class="appearance-none border border-[#E6E6E6] rounded text-[#4D4D4D] pl-4 pr-10 py-2 bg-[#ffffff] font-medium shadow-sm focus:outline-none focus:border-cyan-500 cursor-pointer rtl:pl-10 rtl:pr-4"
          >
            <option value="newest">{{ 'Seller.Latest' | translate }}</option>
            <option value="oldest">{{ 'Seller.Oldest' | translate }}</option>
            <option value="price-asc">{{ 'Seller.Cheapest' | translate }}</option>
            <option value="price-desc">
              {{ 'Seller.MostExpensive' | translate }}
            </option>
          </select>
          <span
            class="absolute top-1/2 -translate-y-1/2 pointer-events-none text-2xs text-slate-500 right-3 rtl:left-3 rtl:right-auto"
            >▼</span
          >
        </div>
      </div>
    </div>

    <div
      class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-4 gap-y-6"
    >
      @for (product of products(); track product.slug) {
        <app-product-card [data]="product" class="h-full block"></app-product-card>
      }
    </div>

    @if (isLoading()) {
      <div class="text-center py-4 text-gray-500">
        {{ 'Seller.LoadingMore' | translate }}
      </div>
    }
  </main>
</div>
